import Reveal from "@/components/Reveal";

export default function CoreIdea() {
  return (
    <section className="bg-[#09090B] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-28 sm:py-40">
        <Reveal>
          <h2
            data-testid="core-idea-heading"
            className="font-serif-d font-black tracking-tight leading-[1.02] text-4xl sm:text-6xl lg:text-7xl text-[#F3F0E8] max-w-5xl"
          >
            LinkedIn isn't about posting more.{" "}
            <span className="italic font-semibold text-[#F3F0E8]/45">
              It's about becoming known for something.
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p data-testid="core-idea-text" className="text-base sm:text-xl text-[#F3F0E8]/60 leading-relaxed mt-10 max-w-2xl">
            The strongest personal brands are built around a clear point of
            view, consistent ideas and content that people remember.
          </p>
        </Reveal>
      </div>

      <div className="border-y border-[#F3F0E8]/10 py-5 overflow-hidden" aria-hidden="true">
        <div className="animate-marquee flex whitespace-nowrap w-max">
          {[0, 1].map((n) => (
            <span key={n} className="flex items-center">
              {["Point of view", "Consistency", "Positioning", "Content", "Creative", "Reputation", "Audience", "Opportunity"].map((w) => (
                <span key={`${n}-${w}`} className="font-serif-d italic text-2xl sm:text-3xl text-[#F3F0E8]/25 mx-6">
                  {w} <span className="text-[#118C4F]/50 not-italic mx-2">·</span>
                </span>
              ))}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
